import React, {Component} from "react";
import OrderApi from "../../api/OrderApi";
import CommonApi from "../../api/CommonApi";
import * as queryString from "query-string";
import {withToastManager} from "react-toast-notifications";
import Footer from "../Footer";
import token from "./Token";

const PUBLIC_PATH = process.env.REACT_APP_PUBLIC_PATCH;

class Main extends Component {

    token = "";
    connect={};
    /** Accumulated Text1 blocks per Connect: { blocks: string[], seen: { [normalizedBlock]: true } }. */
    connectTextLine1 = {};

    columnRequired = [
        'Order_customer_customerNumber',
        'Line_product_productNumber',
        'Line_unit_unitNumber',
        'Line_quantity',
        'Order_currency',
        // 'Order_paymentTerms_paymentTermsNumber',
        'Order_layout_layoutNumber',
    ];

    /** Fields that support multi-column text templates ({1}, {column 1}, …). */
    columnTemplateFields = [
        'Order_notes_textLine1',
    ];

    /**
     * Stored inside fixedData so column templates persist even on older backends
     * that only save content + fixedData (and ignore top-level columnTemplate).
     * Not a real e-conomic field — stripped before import.
     */
    columnTemplateStorageKey = '__columnTemplate';

    tableModel = {
        Temp_Connect: "Connect",
        Temp_Number: "Number",
        Order_customer_customerNumber: "Customer no.",
        Order_recipient_ean: "EAN No.",
        Order_recipient_attention_customerContactNumber: "Attention Person",
        Line_product_productNumber: "Product no.",
        Line_description: "Product name",
        Line_quantity: "Quantity",
        Line_unit_unitNumber: "Unit",
        Line_unitNetPrice: "Unit price",
        Line_discountPercentage: "Discount",
        Line_departmentalDistribution_departmentalDistributionNumber: "Department",
        // Line_InventoryLocationHandle_Number: "Location",
        Order_date: "Invoice date",//
        Order_paymentTerms_paymentTermsNumber: "Payment terms",
        Order_dueDate: "Due date",//
        Order_currency: "Currency", //
        Order_deliveryLocation_deliveryLocationNumber: "Delivery location",//
        Order_delivery_address: "Address",//
        Order_delivery_zip: "Post code", //
        Order_delivery_city: "City", //
        Order_delivery_country: "Country", //
        Order_delivery_deliveryTerms: "Delivery terms",//
        Order_delivery_deliveryDate: "Delivery date", //
        Order_notes_heading: "Heading",//
        Order_notes_textLine1: "Text1",//
        Order_notes_textLine2: "Text2",//
        Order_references_customerContact_customerContactNumber: "Your ref.",//
        Order_references_salesPerson_employeeNumber: "Our ref.", //
        // Order_OurReference2Handle_Number: "Our ref. 2", //
        Order_references_other: "Other ref.", //
        Order_project_projectNumber: "Project", //
        Order_recipient_publicEntryNumber: "CVR number",//
        Order_layout_layoutNumber: "Layout",
        Line_accrual_startDate: "Accrual start date",
        Line_accrual_endDate: "Accrual end date",
        Order_documents: "Documents", //
        Order_customer_name: "Customer name",
        Line_barCode: "Barcode",
    };

    constructor(props) {

        super(props);
        // this.handleColumnChange = this.handleColumnChange.bind(this);
        this.state = {
            fileName:"",
            dataRaw:"",
            dataTable: [],
            dataTableStatus: [],
            dataColumnIndex: {},
            dataColumnFixedValue: {},
            dataColumnTemplate: {},
            dataImportType: "order",
            skipLines: 0,
            loading: false,
            isUploading: false,
            progress: null,
            templateOption: false,
            templateData: {},
            preparingData: {},
            token: '',
            charSep:'',
            groupByCustomer:0,
            lineBreak:0,
            stop:false,
            activeStop:false,
            files: [],
            isDragging: false,
            agreementNumber: '',
            companyName: '',
            isMessageBoxOpen: false,
            hasNewMessage: false,
            messages: [],
            messageFilter: 'all', // 'all' | 'success' | 'error'
            feature: {},
        };
        this.input = {};
        this.messageContentRef = React.createRef();
        this.documentUploadHistory = [];
    }

    componentDidMount() {
        this.startLoading();
        let {token} = queryString.parse(this.props.location.search);
        this.token = token;
        this.setState({token: this.token});

        let {preparingData} = this.state;
        preparingData = {};

        Promise.all([
            CommonApi.getEmployees(this.token).then((data) => {
                preparingData['employees'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getPaymentTerms(this.token).then((data) => {
                preparingData['paymentTerms'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getCurrencies(this.token).then((data) => {
                preparingData['currencies'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getDepartments(this.token).then((data) => {
                preparingData['departments'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getUnits(this.token).then((data) => {
                preparingData['units'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getLayout(this.token).then((data) => {
                preparingData['layouts'] = data.data.collection;
                this.setState({preparingData});
            }),
            CommonApi.getListOfTemplate(this.token).then((data) => {
                this.setState({templateData: data.data.data});
            }),
            CommonApi.checkLicense(this.token).then((data) => {
                    if (!data.data.success) {
                        this.props.history.push(PUBLIC_PATH + "?message=" + data.data.message);
                    } else {
                        this.setState({
                            agreementNumber: data.data.data.agreementNumber,
                            companyName: data.data.data.companyName,
                            feature: {...data.data.data.feature},
                        });
                    }
                }
            )
        ]).catch((e)=>{
            this.props.toastManager.add("Error: " + e.message , {
                appearance: 'error',
                autoDismiss: true,
            });
        }).finally(()=>{
            this.endLoading();
        });
    }

    columnLength = 0;

    startLoading() {
        document.body.classList.remove('loaded');
    }

    endLoading() {
        document.body.classList.add('loaded');
    }

    /**
     * Resolve placeholders in a column template, merging per row.
     * Supports {1}, {2} and {column 1}, {Column 2} (1-based, matches "Column N" in UI).
     *
     * Each template line is kept only when every placeholder on that line has a value
     * (or the line has no placeholders). Lines with any empty placeholder are skipped.
     * Returns null when nothing remains — callers leave the field unset.
     */
    resolveColumnTemplate(template, rowData) {
        if (template == null || String(template).trim() === '') {
            return null;
        }

        const cellValue = (index) => {
            if (index < 0 || rowData == null || rowData[index] == null) {
                return '';
            }
            return String(rowData[index]).trim();
        };

        const placeholderRe = /\{(?:column\s*)?(\d+)\}/gi;
        const lines = String(template).replace(/\r\n/g, '\n').replace(/\r/g, '\n').split('\n');
        const merged = [];

        lines.forEach((line) => {
            const placeholders = [];
            let match;
            const lineRe = /\{(?:column\s*)?(\d+)\}/gi;
            while ((match = lineRe.exec(line)) !== null) {
                placeholders.push(parseInt(match[1], 10) - 1);
            }

            if (placeholders.length > 0) {
                const hasEmpty = placeholders.some((index) => cellValue(index) === '');
                if (hasEmpty) {
                    return;
                }
            } else if (line.trim() === '') {
                return;
            }

            merged.push(line.replace(placeholderRe, (full, colNum) => {
                return cellValue(parseInt(colNum, 10) - 1);
            }));
        });

        if (merged.length === 0) {
            return null;
        }
        return merged.join('\n');
    }

    isColumnTemplateField(field) {
        return this.columnTemplateFields.indexOf(field) !== -1;
    }

    /**
     * Keep only templates for allowed fields (e.g. Text1).
     */
    sanitizeColumnTemplate(columnTemplate) {
        const sanitized = {};
        Object.keys(columnTemplate || {}).forEach((field) => {
            if (!this.isColumnTemplateField(field)) {
                return;
            }
            const value = columnTemplate[field];
            if (value != null && String(value).trim() !== '') {
                sanitized[field] = value;
            }
        });
        return sanitized;
    }

    /**
     * Read column templates from a saved mapping template entry.
     * Prefers top-level columnTemplate; falls back to fixedData.__columnTemplate.
     */
    extractColumnTemplateFromSaved(selected) {
        const fromTop = this.sanitizeColumnTemplate(selected.columnTemplate || {});
        if (Object.keys(fromTop).length > 0) {
            return fromTop;
        }
        const raw = selected.fixedData && selected.fixedData[this.columnTemplateStorageKey];
        if (!raw) {
            return {};
        }
        try {
            const parsed = typeof raw === 'string' ? JSON.parse(raw) : raw;
            return this.sanitizeColumnTemplate(parsed || {});
        } catch (e) {
            return {};
        }
    }

    /**
     * Build save payload. Dual-writes columnTemplate into fixedData so older
     * backends that ignore the top-level key still persist Text1 templates.
     */
    buildMappingTemplatePayload(name, dataColumnIndex, dataColumnFixedValue, dataColumnTemplate) {
        const columnTemplate = this.sanitizeColumnTemplate(dataColumnTemplate);
        const fixedData = {...dataColumnFixedValue};
        delete fixedData[this.columnTemplateStorageKey];
        if (Object.keys(columnTemplate).length > 0) {
            fixedData[this.columnTemplateStorageKey] = JSON.stringify(columnTemplate);
        }
        return {
            name,
            content: {...dataColumnIndex},
            fixedData,
            columnTemplate,
        };
    }

    stripColumnTemplateStorage(fixedData) {
        const result = {...(fixedData || {})};
        delete result[this.columnTemplateStorageKey];
        return result;
    }

    /**
     * Mapped cell value for preview / display.
     * Priority: column template (allowed fields only) > fixed value > Load from column.
     * If a template is set but all placeholder columns are empty, show blank (do not set).
     */
    getMappedFieldValue(field, rowData) {
        const {dataColumnIndex, dataColumnFixedValue, dataColumnTemplate} = this.state;
        const template = dataColumnTemplate[field];
        if (this.isColumnTemplateField(field) && template != null && String(template).trim() !== '') {
            const resolved = this.resolveColumnTemplate(template, rowData);
            return resolved == null ? '' : resolved;
        }
        const fixed = dataColumnFixedValue[field];
        if (fixed != null && fixed !== '' && field !== this.columnTemplateStorageKey) {
            return fixed;
        }
        const column = dataColumnIndex[field];
        if (column === '' || column == null) {
            return '';
        }
        return rowData[column] != null ? rowData[column] : '';
    }

    /**
     * Per-row mapping overrides for API.
     * When a column template resolves to null (all placeholder columns empty),
     * the field is left unset (removed from fixed + Load from for that row).
     */
    buildRowMappingOverrides(rowData) {
        const {dataColumnFixedValue, dataColumnTemplate, dataColumnIndex} = this.state;
        const fixed = this.stripColumnTemplateStorage(dataColumnFixedValue);
        const index = {...dataColumnIndex};

        this.columnTemplateFields.forEach((field) => {
            const template = dataColumnTemplate[field];
            if (template == null || String(template).trim() === '') {
                return;
            }
            const resolved = this.resolveColumnTemplate(template, rowData);
            if (resolved == null) {
                delete fixed[field];
                delete index[field];
            } else {
                fixed[field] = resolved;
            }
        });

        return {dataColumnFixedValue: fixed, dataColumnIndex: index};
    }

    /**
     * Append this row's resolved Text1 block into the Connect group's notes.
     * Dedupe is by the whole resolved block for the row (not per line):
     * identical Att/Ref/Order nr blocks are skipped; a shorter/different block is merged.
     * Mutates rowFixedValues with the full merged Text1 so far.
     */
    mergeConnectTextLine1(connectId, rowFixedValues, rowData) {
        const field = 'Order_notes_textLine1';
        if (!connectId) {
            return false;
        }

        const template = (this.state.dataColumnTemplate || {})[field];
        const rowBlock = this.resolveColumnTemplate(template, rowData);
        if (rowBlock != null && String(rowBlock).trim() !== '') {
            if (!this.connectTextLine1[connectId]) {
                this.connectTextLine1[connectId] = {blocks: [], seen: {}};
            }
            const store = this.connectTextLine1[connectId];
            const key = this.normalizeTextLine1Block(rowBlock);
            if (!store.seen[key]) {
                store.seen[key] = true;
                store.blocks.push(rowBlock);
            }
        }

        const store = this.connectTextLine1[connectId];
        if (store && store.blocks.length) {
            rowFixedValues[field] = store.blocks.join('\n');
            return true;
        }
        return false;
    }

    normalizeTextLine1Block(block) {
        return String(block)
            .replace(/\r\n/g, '\n')
            .replace(/\r/g, '\n')
            .split('\n')
            .map((line) => line.trim())
            .filter((line) => line !== '')
            .join('\n');
    }

    hasText1ColumnTemplate() {
        const template = (this.state.dataColumnTemplate || {})['Order_notes_textLine1'];
        return template != null && String(template).trim() !== '';
    }

    saveTemplate(e) {
        let {dataColumnIndex, dataColumnFixedValue, dataColumnTemplate} = this.state;
        const name = (this.input['txtTemplate'] && this.input['txtTemplate'].value || '').trim();
        if (!name) {
            this.props.toastManager.add('Please enter a template name before saving.', {
                appearance: 'warning',
                autoDismiss: true,
            });
            return;
        }
        this.startLoading();
        if (Array.isArray(dataColumnIndex)) {
            dataColumnIndex = Object.fromEntries(dataColumnIndex);
        }
        const params = this.buildMappingTemplatePayload(
            name, dataColumnIndex, dataColumnFixedValue, dataColumnTemplate
        );
        console.log(params);
        CommonApi.saveListOfTemplate(this.token, params).then((data) => {
            if (data.data && data.data.success === false) {
                this.props.toastManager.add(data.data.message || 'Failed to save template.', {
                    appearance: 'error',
                    autoDismiss: true,
                });
                return;
            }
            this.setState({templateData: data.data.data, templateOption: false});
            this.props.toastManager.add('Template saved (including Text1 column template).', {
                appearance: 'success',
                autoDismiss: true,
            });
        }).catch((err) => {
            this.props.toastManager.add('Failed to save template: ' + (err.message || 'unknown error'), {
                appearance: 'error',
                autoDismiss: true,
            });
        }).finally(() => {
            setInterval(() => this.endLoading(), 1000);
        });
    }

    saveTemplateFromList(e) {
        let {dataColumnIndex, dataColumnFixedValue, dataColumnTemplate} = this.state;
        const name = (this.input['sltTemplate'] && this.input['sltTemplate'].value || '').trim();
        if (!name) {
            this.props.toastManager.add('Please select a template to overwrite.', {
                appearance: 'warning',
                autoDismiss: true,
            });
            return;
        }
        this.startLoading();
        if (Array.isArray(dataColumnIndex)) {
            dataColumnIndex = Object.fromEntries(dataColumnIndex);
        }
        const params = this.buildMappingTemplatePayload(
            name, dataColumnIndex, dataColumnFixedValue, dataColumnTemplate
        );
        console.log(params);
        CommonApi.saveListOfTemplate(this.token, params).then((data) => {
            if (data.data && data.data.success === false) {
                this.props.toastManager.add(data.data.message || 'Failed to save template.', {
                    appearance: 'error',
                    autoDismiss: true,
                });
                return;
            }
            this.setState({templateData: data.data.data});
            this.props.toastManager.add('Template saved (including Text1 column template).', {
                appearance: 'success',
                autoDismiss: true,
            });
        }).catch((err) => {
            this.props.toastManager.add('Failed to save template: ' + (err.message || 'unknown error'), {
                appearance: 'error',
                autoDismiss: true,
            });
        }).finally(() => {
            setInterval(() => this.endLoading(), 1000);
        });
    }

    loadTemplate(e) {

        return new Promise((resolve, reject) => {
            this.startLoading();
            try {
                let {templateData} = this.state;
                const selected = templateData[this.input['sltTemplate'].value] || {};
                // Old saved mapping templates may omit columnTemplate — default to {}.
                const dataColumnIndex = selected.content
                    ? {...selected.content}
                    : {};
                const dataColumnFixedValue = this.stripColumnTemplateStorage(
                    selected.fixedData ? {...selected.fixedData} : {}
                );
                const dataColumnTemplate = this.extractColumnTemplateFromSaved(selected);
                this.setState({dataColumnIndex, dataColumnFixedValue, dataColumnTemplate});
                resolve(true);
            } catch (e) {
                reject("Error");
            }
        }).finally(() => {
            setInterval(() => this.endLoading(), 1000);
            let groupByCustomer = this.state.groupByCustomer;
            if (groupByCustomer)
                this.setConnectGroupByCustomer();
        });

        // $('#load-template').append('<span class="spinner-grow spinner-grow-sm"></span>');
        // e.target.append(<span className="spinner-grow spinner-grow-sm"></span>);
    }

    removeTemplate() {
        this.startLoading();
        CommonApi.deleteListOfTemplate(this.token, this.input['sltTemplate'].value).then((data) => {
            this.setState({templateData: data.data.data});
        }).finally(() => {
            setInterval(() => this.endLoading(), 1000);
        });
    }

    async handleFileChose(e) {
        this.startLoading();
        this.setState({isUploading: true});
        try {
            let file = e.target.files[0];
            this.setState({fileName:file.name});
            // Create an object of formData
            const formData = new FormData();
            // Update the formData object
            formData.append(
                "file",
                file,
                "file"
            );
            let dataTable = [];
            await CommonApi.uploadFile(token, formData).then((response) => {
                if (response?.data?.data) {
                    dataTable = response?.data?.data;
                }
            }).catch((e) => {
                console.log(e.message);
            }).finally(() => {

                dataTable.map((value) => {
                    let dataTableLength = value.length;
                    if (this.columnLength < dataTableLength)
                        this.columnLength = dataTableLength;
                });

                this.setState({dataTable});
            });

        } catch (e) {
            console.log('uploading error: ', e.message);
        } finally {
            this.setState({isUploading: false});
            setInterval(() => this.endLoading(), 1000);
        }

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // $('.toolt').tooltip({ boundary: 'window' });
        // console.log($('.toolt').tooltip());
    }

    async stop(){
        const newMessages = [];
        newMessages.push({ text: `### STOP ###`, type: 'warning' });
        this.setState(prevState => ({
            messages: [...prevState.messages, ...newMessages],
            hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0,
            stop:true,
            activeStop:false
        }), this.scrollToBottom);
    }

    async import() {
        let {dataTable, progress, skipLines} = this.state;
        this.setState({activeStop:true});
        const total = dataTable.length - skipLines;
        let importType = this.input['sltImportType'].value;
        let groupByCustomer = this.state.groupByCustomer;
        let lineBreak = this.state.lineBreak;
        let preparingData = this.state.preparingData;

        // Random key cho mỗi lần import, backend dùng để cache theo từng lần submit
        const importId = Math.random().toString(36).substring(2) + Date.now().toString(36);

        let count = 1;

        if (total > 0) {
            progress = 0;
            this.setState({progress});
        }
        this.connect = {};
        this.connectTextLine1 = {};
        // setInterval()
        for (let index = 0; index<dataTable.length;index++) {
            if(this.state.stop) break;
            if (index < skipLines) continue;
            let status = 1;
            let {dataTableStatus} = this.state;
            dataTableStatus[index] = status; //1: pending | 2: complete | 3: none
            this.setState({dataTableStatus});

            const rowMapping = this.buildRowMappingOverrides(dataTable[index]);
            const rowFixedValues = rowMapping.dataColumnFixedValue;
            const rowColumnIndex = rowMapping.dataColumnIndex;

            let customerNo = rowFixedValues['Order_customer_customerNumber']??dataTable[index][rowColumnIndex['Order_customer_customerNumber']] ?? null;
            let connectId = dataTable[index][rowColumnIndex['Temp_Connect']] ?? null;
            let tempConnectFixValue = rowFixedValues['Temp_Connect']??'';
            // Explicit Connect mapping/fixed only — not the customerNumber suffix alone.
            let hasExplicitConnect = false;
            // if(!groupByCustomer){
                if(tempConnectFixValue !== "") {
                    connectId = rowFixedValues['Temp_Connect'];
                    hasExplicitConnect = true;
                } else if (connectId != null && String(connectId).trim() !== '') {
                    hasExplicitConnect = true;
                }

                if(connectId == null)
                    connectId = "";
                if(customerNo == null)
                    customerNo = "";
                connectId = connectId.toString().trim() + customerNo.toString().trim();
                try{
                    connectId = connectId !== null ? connectId.trim() : "";
                }catch (e){}
          /*  }else{
                connectId = customerNo;
            }*/

            // Only merge Text1 across rows when Connect is used + Text1 column template is set.
            // Avoids changing legacy imports (no Connect / Load-from Text1 / fixed Text1).
            let updateDraftNotes = false;
            if (hasExplicitConnect && this.hasText1ColumnTemplate()) {
                updateDraftNotes = this.mergeConnectTextLine1(connectId, rowFixedValues, dataTable[index]);
            }


            if(connectId !== "" && !this.connect[connectId])
                this.connect[connectId] = "";

            // if(connectId !== "") this.connect[connectId] = this.connect[connectId]??"";
            let colDocuments = dataTable[index][rowColumnIndex['Order_documents']]??'';
            let stt = index+1;
            const newMessages = [];
            await OrderApi.addOne(importType, this.token, {
                importId,
                numberRows: total,
                rowData: dataTable[index],
                dataColumnIndex: rowColumnIndex,
                dataColumnFixedValue: rowFixedValues,
                tableModel: this.tableModel,
                connect:this.connect,
                preparingData:{units:preparingData.units,paymentTerms:preparingData.paymentTerms,employees:preparingData.employees,layouts:preparingData.layouts},
                groupByCustomer,
                lineBreak,
                updateDraftNotes,
            }).then((data) => {
                if (data.data.success) {
                    status = 2;
                    this.connect[connectId] = data.data.data;
                    newMessages.push({ text: `#${stt} import successful.`, type: 'success' });

                    if(!this.documentUploadHistory.includes(connectId) && colDocuments !== ''){
                        const arrDocuments = colDocuments.split(",");
                        if (this.state.files.length > 0) {
                            const formData = new FormData();
                            this.state.files.forEach((file, index) => {
                                if(arrDocuments.includes(file.name)){
                                    formData.append(`file-${index}`, file);
                                }
                            });
                            if([...formData.entries()].length > 0){
                                OrderApi.uploadDocument(importType, this.token,{'connectId':this.connect[connectId],'importId':importId},formData).then((data)=>{
                                    const newMessages = [];
                                    if (data.data.success) {
                                        newMessages.push({ text: `#${stt} upload document(s) successful.`, type: 'success' });
                                    }else{
                                        newMessages.push({ text: `#${stt}  upload document(s) failed. Error: ${data.data.message}`, type: 'error' });
                                    }
                                    this.setState(prevState => ({
                                        messages: [...prevState.messages, ...newMessages],
                                        hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0
                                    }), this.scrollToBottom);
                                });
                            }
                        }

                        this.documentUploadHistory.push(connectId);
                    }
                } else {
                    status = 3;
                    newMessages.push({ text: `#${stt}  import failed. Error: ${data.data.message}`, type: 'error' });
                }
                this.setState(prevState => ({
                    messages: [...prevState.messages, ...newMessages],
                    hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0
                }), this.scrollToBottom);
            }).catch(error => {
                status = 3;
                newMessages.push({ text: `#${stt}  import failed. Error: ${error.message}`, type: 'error' });
            }).finally(() => {
                dataTableStatus[index] = status;
                progress = Math.ceil(count * 100 / total); // 5 => 100
                if (progress > 100) progress = 100;
                this.setState({dataTableStatus, progress});
                count++;

            });
        }
        const newMessages = [];
        newMessages.push({ text: `### DONE ###`, type: 'success' });
        this.setState(prevState => ({
            messages: [...prevState.messages, ...newMessages],
            hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0,
            activeStop:false
        }), this.scrollToBottom);
        // this.setState({activeStop:false});
    }

    importDocument(){

    }

    setConnectGroupByCustomer(){
        let {dataColumnIndex,dataColumnFixedValue} = this.state;
        dataColumnIndex['Temp_Connect'] = dataColumnIndex['Order_customer_customerNumber'];
        dataColumnFixedValue['Temp_Connect'] = dataColumnFixedValue['Order_customer_customerNumber'];
        this.setState({dataColumnIndex,dataColumnFixedValue});
    }

    handleChange(e) {
        let {name, value} = e.target;
        if (name === "importType") {
            this.setState({dataImportType: value});
        } else if (name === "groupByCustomer") {
            this.setState({groupByCustomer: e.target.checked?1:0});
            this.setConnectGroupByCustomer();
        } else if (name === "lineBreak") {
            this.setState({lineBreak: e.target.checked?1:0});
        } else if (name === "skipLines") {
            this.setState({skipLines: value});
        } else if (name === "columnMap") {
            let columnIndex = e.target.getAttribute("column-index");
            let {dataColumnIndex} = this.state;
            dataColumnIndex[columnIndex] = value;
            this.setState({dataColumnIndex});
        } else if (name === "columnFix") {
            let columnIndex = e.target.getAttribute("column-index");
            let {dataColumnFixedValue} = this.state;
            dataColumnFixedValue[columnIndex] = value;
            this.setState({dataColumnFixedValue});
            // console.log(this.state.dataColumnFixedValue);
        } else if (name === "columnTemplate") {
            let columnIndex = e.target.getAttribute("column-index");
            if (!this.isColumnTemplateField(columnIndex)) {
                return;
            }
            this.setState((prevState) => ({
                dataColumnTemplate: {
                    ...prevState.dataColumnTemplate,
                    [columnIndex]: value,
                },
            }));
        }
        else if (name === "char-sep") {
        }
    }

    getLineStatus(index, msg = '') {
        let {dataTableStatus} = this.state;
        if (dataTableStatus[index] === 1) {
            return <span className="spinner-grow spinner-grow-sm"></span>;
        } else if (dataTableStatus[index] === 2) {
            return <span className="badge badge-success">Complete</span>;
        } else if (dataTableStatus[index] === 3) {
            return <span className="badge badge-warning"
                         data-toggle="tooltip"
                         data-placement="top">Error</span>
        }
        return '';
    }
    handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        const newMessages = this.validateFiles(selectedFiles);
        this.setState(prevState => ({
            files: [...prevState.files, ...selectedFiles.filter(file => file.type === 'application/pdf')],
            messages: [...prevState.messages, ...newMessages],
            hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0
        }), this.scrollToBottom);
    }

    handleDrop = (event) => {
        event.preventDefault();
        const droppedFiles = Array.from(event.dataTransfer.files);
        const newMessages = this.validateFiles(droppedFiles);
        this.setState(prevState => ({
            isDragging: false,
            files: [...prevState.files, ...droppedFiles.filter(file => file.type === 'application/pdf')],
            messages: [...prevState.messages, ...newMessages],
            hasNewMessage: newMessages.length > 0 || prevState.messages.length === 0
        }), this.scrollToBottom);
    }

    validateFiles = (files) => {
        const messages = [];
        const maxSize = 9 * 1024 * 1024; // 9MB
        const warningSize = 8 * 1024 * 1024; // 8MB for warning
        files.forEach(file => {
            if (file.type !== 'application/pdf') {
                messages.push({ text: `${file.name} is not a PDF file`, type: 'error' });
            } else if (file.size > maxSize) {
                messages.push({ text: `${file.name} exceeds the size limit (9MB)`, type: 'error' });
            } else if (file.size > warningSize) {
                messages.push({ text: `${file.name} is close to size limit (${(file.size / 1024 / 1024).toFixed(2)}MB)`, type: 'warning' });
            } else {
                messages.push({ text: `${file.name} added successfully (${(file.size / 1024 / 1024).toFixed(2)}MB)`, type: 'success' });
            }
        });
        return messages;
    }

    handleDragOver = (event) => {
        event.preventDefault();
        this.setState({ isDragging: true });
    }

    handleDragLeave = (event) => {
        event.preventDefault();
        this.setState({ isDragging: false });
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.state.files.length > 0 && !this.state.messages.some(msg => msg.type === 'error')) {
            const formData = new FormData();
            this.state.files.forEach((file, index) => {
                formData.append(`file-${index}`, file);
            });
            console.log('Files to upload:', this.state.files);
        }
    }

    removeFile = (indexToRemove) => {
        this.setState(prevState => ({
            files: prevState.files.filter((_, index) => index !== indexToRemove),
            messages: prevState.messages.filter(msg => !msg.text.includes(prevState.files[indexToRemove].name))
        }));
    }

    toggleMessageBox = () => {
        this.setState(prevState => ({
            isMessageBoxOpen: !prevState.isMessageBoxOpen,
            hasNewMessage: false
        }));
    }

    scrollToBottom = () => {
        if (this.messageContentRef.current && this.state.isMessageBoxOpen) {
            this.messageContentRef.current.scrollTop = this.messageContentRef.current.scrollHeight;
        }
    }
    clearMessages = () => {
        this.setState({ messages: [], hasNewMessage: false });
    }
    render() {
        const {files, isDragging, messages, isMessageBoxOpen, hasNewMessage, messageFilter, agreementNumber, companyName, isUploading, dataTable, dataColumnIndex, progress, skipLines, templateOption, preparingData, templateData, activeStop, dataColumnFixedValue, dataColumnTemplate} = this.state;
        let headerTable = [];
        let selectOption = [];
        headerTable.push(<td key={-1}>Line</td>);
        selectOption.push(
            <option key={""} value={""}>
                - None -
            </option>
        );
        for (let j = 0; j < this.columnLength; j++) {
            headerTable.push(<td key={j}>Column {j + 1}</td>);
            selectOption.push(
                <option key={j} value={j}>
                    Column {j + 1}
                </option>
            );
        }

        console.log('feature',this.state.feature);
        return (
            <div className="">
                {/*<NavBar />*/}
                <main className="dash-content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-12">
                         {/*       <div className="alert alert-warning alert-dismissible"><strong>Notice!</strong>  This is a demo version
                                </div>*/}
                                <div className="card spur-card">
                                    <div className="card-header d-flex justify-content-between align-items-center">
                                        <div className="d-flex align-items-center">
                                            <div className="spur-card-icon mr-2">
                                                <i className="fas fa-chart-bar"></i>
                                            </div>
                                            <div className="spur-card-title company-info">
                                                {agreementNumber} - {companyName}
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <a href={`${process.env.REACT_APP_HOME_PAGE}/docs/document_smartcsv.pdf`} target="_blank" rel="noopener noreferrer" className="ml-2 text-muted" title="Open documentation">
                                                <i className="fas fa-book"></i> Help Document
                                            </a>
                                        </div>
                                    </div>
                                    <div className="card-body ">
                                        <div className="row">
                                            <div className="col-xl-6">
                                                <div className="form-group">
                                                    <label className="">Token</label>
                                                    <div className="input-group">
                                                        <input name="token" className="form-control" disabled={true}
                                                               value={this.state.token}
                                                               onChange={this.handleChange.bind(this)}/>
                                                        <button type="button"
                                                                onClick={() => this.props.history.push(PUBLIC_PATH + "/")}
                                                                className="btn btn-light">Change token
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="row">

                                                        <div className="col-xl-4">
                                                            <label className="">Type</label>
                                                            <select defaultValue="invoice" name="importType" className={"form-control"}
                                                                    ref={(input) => {
                                                                        this.input['sltImportType'] = input
                                                                    }}
                                                            >
                                                                <option value="order">Order</option>
                                                                <option value="invoice">Invoice</option>
                                                                <option value="quote">Quote</option>
                                                            </select>
                                                        </div>

                                                        <div className="upload-btn-wrapper col-xl-8">
                                                            {/*<label className="">Character separate</label>*/}
                                                            <button className="btn btn-outline-secondary"
                                                                    type="button"
                                                                    style={{position:'absolute',bottom:0}}
                                                                    disabled={isUploading}>
                                                                {isUploading &&
                                                                    <span className="spinner-border spinner-border-sm" role="status"
                                                                          aria-hidden="true"></span>}
                                                                <span> {isUploading ? 'Uploading...' : 'Upload file (csv, xlsxm,...'}<input
                                                                    disabled={isUploading}
                                                                    className="btn btn-outline-success"
                                                                    id="exampleFormControlSelect1"
                                                                    type="file"
                                                                    onChange={(e) => this.handleFileChose(e)}
                                                                /></span>
                                                            </button>
                                                            <code style={{textDecoration:"underline"}}>{this.state.fileName}</code>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="row">
                                                        <div className="col-xl-4">
                                                            <label className="">Skip lines</label>
                                                            <input name="skipLines" className="form-control"
                                                                   onChange={this.handleChange.bind(this)} type="number"
                                                                   min={0}/>
                                                        </div>
                                                        <div className="col-xl-8">
                                                            <label className="">Template <i
                                                                data-toggle="tooltip" data-placement="top"
                                                                title="Click to switch other options"
                                                                onClick={() => {
                                                                    this.setState({templateOption: !templateOption});
                                                                }}
                                                                className="fas fa-caret-square-right ico-template toolt"></i></label>
                                                            <div className={"input-group"}>
                                                                {(() => {
                                                                    if (templateOption)
                                                                        return (
                                                                            <>
                                                                                <input
                                                                                    ref={(input) => {
                                                                                        this.input['txtTemplate'] = input
                                                                                    }}
                                                                                    className="form-control"/>
                                                                                <button type="button"
                                                                                        onClick={this.saveTemplate.bind(this)}
                                                                                        className="btn btn-light">Save
                                                                                </button>
                                                                            </>
                                                                        );
                                                                    else {
                                                                        let options = [];
                                                                        options.push(<option key={-1} value={""}></option>);
                                                                        (Object.keys(templateData)).map((index) => {
                                                                            options.push(<option key={index}
                                                                                                 value={index}>{index}</option>);
                                                                        });
                                                                        return (
                                                                            <>
                                                                                <select
                                                                                    ref={(input) => {
                                                                                        this.input['sltTemplate'] = input
                                                                                    }}
                                                                                    className={"form-control"}>{options}</select>
                                                                                <button type="button"
                                                                                        onClick={this.loadTemplate.bind(this)}
                                                                                        className="btn btn-light ">Load
                                                                                </button>
                                                                                <button type="button"
                                                                                        onClick={this.saveTemplateFromList.bind(this)}
                                                                                        className="btn btn-light">Save
                                                                                </button>
                                                                                <button type="button"
                                                                                        onClick={this.removeTemplate.bind(this)}
                                                                                        className="btn btn-light">Delete
                                                                                </button>
                                                                            </>
                                                                        );
                                                                    }
                                                                })()}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="form-group">
                                                    <div className="row">
                                                        <div className="col-xl-12">
                                                            <input name="groupByCustomer"
                                                                   value={this.state.groupByCustomer}
                                                                   onChange={this.handleChange.bind(this)} type="checkbox" /> <label className="">Group By Customer</label>

                                                        </div>
                                                    </div>
                                                    {/*<div className="row">
                                                <div className="col-xl-5">
                                                    <input name="lineBreak"
                                                           value={this.state.lineBreak}
                                                           onChange={this.handleChange.bind(this)} type="checkbox" /> <label className="">Add Line Break</label>

                                                </div>
                                            </div>*/}
                                                </div>
                                            </div>
                                            {(this.state.feature?.f_upload_document ?? 0) === 1 && (
                                                <div className="col-xl-6">
                                                    <div className="upload-container">
                                                        <h5>File pool</h5>
                                                        <div
                                                            className={`drop-zone ${isDragging ? 'dragging' : ''}`}
                                                            onDrop={this.handleDrop}
                                                            onDragOver={this.handleDragOver}
                                                            onDragLeave={this.handleDragLeave}
                                                        >
                                                            <p>Drag and drop PDF files here or</p>
                                                            <input
                                                                type="file"
                                                                multiple
                                                                onChange={this.handleFileChange}
                                                                id="fileInput"
                                                            />
                                                            <label htmlFor="fileInput">Select PDF files</label>
                                                        </div>
                                                        {/*<button
                                                        onClick={this.handleSubmit}
                                                        disabled={files.length === 0}
                                                        className="upload-btn"
                                                    >
                                                        Upload
                                                    </button>*/}

                                                        {files.length > 0 && (
                                                            <div className="file-list">
                                                                <h5>Selected Files:</h5>
                                                                <ul>
                                                                    {files.map((file, index) => (
                                                                        <li key={index}>
                                                                            {file.name} - {(file.size / 1024).toFixed(2)} KB
                                                                            <button
                                                                                onClick={() => this.removeFile(index)}
                                                                                className="remove-btn"
                                                                            >
                                                                                Remove
                                                                            </button>
                                                                        </li>
                                                                    ))}
                                                                </ul>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12">
                                <div className="card spur-card">
                                    <div className="card-header">
                                        <div className="spur-card-icon">
                                            <i className="fas fa-table"></i>
                                        </div>
                                        <div className="spur-card-title"> Data source</div>
                                    </div>
                                    <div
                                        className="card-body df-table-data"
                                    >
                                        {dataTable.length > 0 && (
                                            <table className="table table-striped table-in-card">
                                                <thead>
                                                <tr key={0}>{headerTable}</tr>
                                                </thead>
                                                <tbody>
                                                {dataTable.map((rowData, index) => {
                                                    let indexCol = 0;
                                                    return (
                                                        <tr key={++index}
                                                            className={(index <= skipLines ? 'skip-row' : '')}>
                                                            <td key={indexCol}>{index}</td>
                                                            {Array(this.columnLength)
                                                                .fill(null)
                                                                .map(() => {
                                                                    return (
                                                                        <td key={indexCol}>
                                                                            {rowData[indexCol++]}
                                                                        </td>
                                                                    );
                                                                })}
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12">
                                <div className="card spur-card">
                                    <div className="card-header">
                                        <div className="spur-card-icon">
                                            <i className="fas fa-table"></i>
                                        </div>
                                        <div className="spur-card-title"> Match Data</div>
                                        <div>
                                            <button
                                                type="button"
                                                disabled={activeStop}
                                                className="btn btn-outline-info btn-sm mb-1 df-btn-import"
                                                onClick={this.import.bind(this)}
                                            >
                                                Import <span
                                                className="badge badge-light">{progress !== null && (progress + '%')}</span>
                                            </button>

                                            <button disabled={!activeStop}
                                                type="button"
                                                className="btn btn-outline-secondary btn-sm mb-1 df-btn-stop"
                                                onClick={this.stop.bind(this)}
                                            >
                                                STOP
                                            </button>
                                        </div>
                                        <div className="progress mb-1">
                                            <div
                                                className="progress-bar bg-primary"
                                                role="progressbar"
                                                style={{width: "100%"}}
                                                aria-valuenow="25"
                                                aria-valuemin="0"
                                                aria-valuemax="100"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        className="card-body df-table-data df-table-data-mapping"
                                    >
                                        {dataTable.length > 0 && (
                                            <table className={"table table-striped table-in-card " + (this.state.groupByCustomer?"group-by-customer":"")} >
                                                <thead>
                                                <tr>
                                                    <td></td>
                                                    {Object.keys(this.tableModel).map((index) => {
                                                        return <td key={index}
                                                                   className={this.columnRequired.includes(index) ? 'column-required' : ''}>{this.tableModel[index]}</td>;
                                                    })}
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>Load from</td>
                                                    {Object.keys(this.tableModel).map((index) => {
                                                        return (
                                                            <td key={index}>
                                                                <select
                                                                    value={dataColumnIndex[index] ?? ""}
                                                                    name="columnMap"
                                                                    column-index={index}
                                                                    onChange={this.handleChange.bind(this)}
                                                                >
                                                                    {selectOption}
                                                                </select>
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                <tr className="fixed-value">
                                                    <td>Fixed value</td>
                                                    {Object.keys(this.tableModel).map((index) => {
                                                        return (
                                                            <td key={index}>
                                                                {(() => {
                                                                    let options = [];
                                                                    options.push(<option key={-1} value={""}></option>);
                                                                    let _arr = [
                                                                        "Order_paymentTerms_paymentTermsNumber",
                                                                        "Order_currency",
                                                                        "Line_departmentalDistribution_departmentalDistributionNumber",
                                                                        "Line_unit_unitNumber",
                                                                        "Order_layout_layoutNumber",
                                                                        "Order_references_salesPerson_employeeNumber",
                                                                    ];
                                                                    if (_arr.includes(index)) {
                                                                        switch (index) {
                                                                            case "Order_paymentTerms_paymentTermsNumber":
                                                                                try{
                                                                                    preparingData['paymentTerms'].map((data) => {
                                                                                        options.push(<option
                                                                                            key={data.paymentTermsNumber}
                                                                                            value={data.paymentTermsNumber}>{data.paymentTermsNumber} - {data.name}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }
                                                                                break;
                                                                            case "Order_currency":
                                                                                try{
                                                                                    preparingData['currencies'].map((data) => {
                                                                                        options.push(<option key={data.code}
                                                                                                             value={data.code}>{data.code}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }
                                                                                break;
                                                                            case "Order_layout_layoutNumber":
                                                                                try{
                                                                                    preparingData['layouts'].map((data) => {
                                                                                        options.push(<option key={data.layoutNumber}
                                                                                                             value={data.layoutNumber}>{data.layoutNumber} - {data.name}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }
                                                                                break;
                                                                            case "Line_departmentalDistribution_departmentalDistributionNumber":
                                                                                try{
                                                                                    preparingData['departments'].map((data) => {
                                                                                        options.push(<option
                                                                                            key={data.departmentNumber}
                                                                                            value={data.departmentNumber}>{data.departmentNumber} - {data.name}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }

                                                                                break;
                                                                            case "Line_unit_unitNumber":
                                                                                try{
                                                                                    preparingData['units'].map((data) => {
                                                                                        options.push(<option
                                                                                            key={data.unitNumber}
                                                                                            value={data.unitNumber}>{data.unitNumber} - {data.name}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }

                                                                                break;

                                                                            case "Order_references_salesPerson_employeeNumber":
                                                                                try{
                                                                                    preparingData['employees'].map((data) => {
                                                                                        options.push(<option
                                                                                            key={data.employeeNumber}
                                                                                            value={data.employeeNumber}>{data.employeeNumber} - {data.name}</option>)
                                                                                    });
                                                                                }catch (e) {
                                                                                    console.log(e.message);
                                                                                }

                                                                                break;
                                                                        }

                                                                        return (
                                                                            <select column-index={index}

                                                                                    value={dataColumnFixedValue[index] ?? ""}
                                                                                    onChange={this.handleChange.bind(this)}
                                                                                    name="columnFix">{options}</select>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <input column-index={index}
                                                                                   name="columnFix"
                                                                                   value={dataColumnFixedValue[index]??''}
                                                                                   onChange={this.handleChange.bind(this)}
                                                                            />
                                                                        );
                                                                    }
                                                                })()}
                                                            </td>
                                                        );
                                                    })}
                                                </tr>
                                                <tr className="column-template">
                                                    <td title="Text1 only. Use {1} or {column 1} for Column 1. Template overrides Load from and Fixed value.">
                                                        Template
                                                    </td>
                                                    {Object.keys(this.tableModel).map((field) => {
                                                        if (!this.isColumnTemplateField(field)) {
                                                            return <td key={field}></td>;
                                                        }
                                                        return (
                                                            <td key={field}>
                                                                <textarea
                                                                    column-index={field}
                                                                    name="columnTemplate"
                                                                    rows={3}
                                                                    placeholder={"Att. {1}\nReferencenummer: {2}"}
                                                                    title="Placeholders: {1}, {2} or {column 1}, {column 2} (matches Column N)"
                                                                    value={dataColumnTemplate[field] ?? ''}
                                                                    onChange={this.handleChange.bind(this)}
                                                                />
                                                            </td>
                                                        );
                                                    })}
                                                </tr>

                                                {dataTable.map((rowData, index) => {
                                                    return (
                                                        (index + 1) > skipLines && <tr key={index} className="mapped-preview">
                                                            <td key={index}>{this.getLineStatus(index)} {index + 1 - skipLines}</td>
                                                            {Object.keys(this.tableModel).map((field) => {
                                                                return <td key={field}>{this.getMappedFieldValue(field, rowData)}</td>;
                                                            })}
                                                        </tr>
                                                    );
                                                })}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <div id="loader-wrapper">
                    <div id="loader"></div>
                </div>
                {/* Message Box */}
                <div className={`message-box ${isMessageBoxOpen ? 'open' : 'closed'}`}>
                    <div className="message-toggle" onClick={this.toggleMessageBox}>
                        <span className="message-label">Messages</span>
                        {isMessageBoxOpen ? '◄' : '►'}
                        {!isMessageBoxOpen && messages.length > 0 && hasNewMessage && (
                            <span className="message-notice">!</span>
                        )}
                    </div>
                    <div className="message-content" ref={this.messageContentRef}>
                        <div className="message-header">
                            <h3>Messages</h3>
                            {messages.length > 0 && (
                                <button
                                    onClick={this.clearMessages}
                                    className="clear-btn"
                                >
                                    Clear
                                </button>
                            )}
                        </div>
                        {messages.length > 0 && (
                            <div className="message-filter">
                                <button
                                    className={`message-filter-btn ${messageFilter === 'all' ? 'active' : ''}`}
                                    onClick={() => this.setState({ messageFilter: 'all' })}
                                >
                                    All
                                </button>
                                <button
                                    className={`message-filter-btn ${messageFilter === 'success' ? 'active' : ''}`}
                                    onClick={() => this.setState({ messageFilter: 'success' })}
                                >
                                    Success
                                </button>
                                <button
                                    className={`message-filter-btn ${messageFilter === 'error' ? 'active' : ''}`}
                                    onClick={() => this.setState({ messageFilter: 'error' })}
                                >
                                    Fail
                                </button>
                            </div>
                        )}
                        {(() => {
                            const filtered = messageFilter === 'all'
                                ? messages
                                : messages.filter(msg => msg.type === messageFilter);
                            return filtered.length > 0 ? (
                                <div className="message-list">
                                    {filtered.map((msg, index) => (
                                        <div key={index} className={`message-row ${msg.type} animate-fade-in`}>
                                            <span>{msg.text}</span>
                                        </div>
                                    ))}
                                </div>
                            ) : (
                                <p>{messages.length > 0 ? 'No messages matching filter' : 'No messages'}</p>
                            );
                        })()}
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

}

export default withToastManager(Main);
